import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';

import {EntrySummaryGraphQL} from '../../../graphql-fragments/notebook/__generated/EntrySummaryGraphQL';
import {StageEntrySummaryGraphQL} from '../../../graphql-fragments/workflows/__generated/StageEntrySummaryGraphQL';
import {getSharedSmartChipProps, SharedSmartChipProps} from './ChipUtil';

export interface EntryChipProps extends SharedSmartChipProps<SmartChipType.ENTRY> {
  id: string;
}

export default function EntryChip(props: EntryChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: entry,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.ENTRY>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={FolderItemIcon.Entry}
      isInaccessible={isInaccessible}
      item={entry}
      onClick={handleClickLink}
      url={itemUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}

export function getSecondaryText(entry: EntrySummaryGraphQL | StageEntrySummaryGraphQL): string | null {
  if (!BenchlingConfig.ELN_ENABLE_IDS_IN_ENTRY_CHIPS) {
    return null;
  }
  return entry.humanId || null;
}
